module.exports = __webpack_public_path__ + "static/media/ShadesTop.ad5e6cd2.png";